<!-- 组织机构管理-->

<template>
  <div class="c-profile-content">
    <div class="institutions-vip-box">
      <div class="cs-tab-box">
        <a href="#" @click.prevent="() => changeTab('mine')" :class="{active: selectedTab === 'mine'}">我发起的</a>
        <a href="#" @click.prevent="() => changeTab('sigup')" :class="{active: selectedTab === 'sigup'}">我报名的</a>
      </div>

    </div>
    <ul class="c-profile-lsit set-standards-list" v-for="(item,index) in minelist" :key="'mine'+index" v-show="selectedTab === 'mine'">
      <li class="c-profile-lsit-li" @click="showMineDetail(item)">
        <img src="../../assets/main/biaozhunban.png">
        <div class="c-profile-center-box">
          <h3>{{item.standardName}}</h3>
          <p>{{'发起单位：'+item.organization}}</p>
          <div class="c-btn-box">
            {{'创建时间：'+item.createTime}}
          </div>
        </div>
        <div class="c-standard-right-box">
          <p class="p1">标准进度</p>
          <p class="c-txt-col">{{timelist[item.status]}}</p>
          <a v-show="item.status>=2" href="javascrip:;" @click.stop="queryStandartSigups(item,index)">{{isshowList===`mine${index}`?'收起列表':'查看报名列表'}}</a>
        </div>
      </li>
       <div  class="standart-apply-list" v-show="`mine${index}`==isshowList">
      <table cellpadding="0" cellspacing="0">
        <tr>
          <th>机构名</th>
          <th>联系人</th>
          <th>联系电话</th>
          <th>报名日期</th>
          <th>报名表</th>
        </tr>
        <tr v-for="(app,index) in applylist" :key="'tb'+index">
          <td>{{app.organization}}</td>
          <td>{{app.contacts}}</td>
          <td>{{app.mobile}}</td>
          <td>{{app.createTime}}</td>
          <td><a :href="app.applyTable">下载报名表</a></td>
        </tr>
      </table>
      </div>
    </ul>
    <ul class="c-profile-lsit set-standards-list" v-for="(item,index) in siguplist" :key="index" v-show="selectedTab === 'sigup'">
      <li class="c-profile-lsit-li" @click="showOtherDetail(item)">
        <img src="../../assets/main/biaozhunban.png">
        <div class="c-profile-center-box">
          <h3>{{item.standardName}}</h3>
          <p>{{'发起单位：'+item.organization}}</p>
          <div class="c-btn-box">
            {{'创建时间：'+item.createTime}}
          </div>
        </div>
        <div class="c-standard-right-box">
          <p class="p1">标准进度</p>
          <p class="c-txt-col">{{timelist[item.status]}}</p>
        </div>

      </li>
    </ul>
  </div>
</template>

<script>
  import {
    getStandardsOfMine,
    getStandardsReplyOfMine,
    getStandardAppliesOfShowed
  } from '@/api/standard.js'
  import config from '@/config/index';

  export default {
    name: 'CreateStandard',
    props: {},
    components: {

    },
    data() {
      return {
        selectedTab: 'mine',
        timelist: ['提案', '立项', '起草', '征求意见', '审查', '批准', '发布'],
        minelist: [],
        siguplist: [],
        isshowList:'',
        applylist:[]
      }
    },
    computed: {},
    mounted() {
      this.queryMineStandard()
      this.queryMineSigupStandard()
    },
    methods: {
      changeTab(type) {
        this.selectedTab = type;
      },
      queryMineStandard() {
        const page = 1
        const limit = 10
        this.$http.get(getStandardsOfMine(), {
          page,
          limit
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.minelist = res.data.list
          }
        });
      },
      queryMineSigupStandard() {
        const page = 1
        const limit = 10
        this.$http.get(getStandardsReplyOfMine(), {
          page,
          limit
        }).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.siguplist = res.data.list
          }
        });
      },
      queryStandartSigups(item,index) {
        if(this.isshowList===`mine${index}`){
          this.isshowList=''
          this.applylist = []
          return
        }
        this.isshowList = `mine${index}`
        this.$http.get(getStandardAppliesOfShowed(item.sid)).then((res) => {
          console.log(res);
          if (res.code === 1) {
              this.applylist = res.data
              for(var i=0;i<this.applylist.length;i++){
                var item = this.applylist[i]
                var applyTable = JSON.parse(item.applyTable)[0].name
                item.applyTable = `${config.HOST_IMG}${applyTable}`
              }
          }else{
            this.applylist = []
          }
        });
      },
      showMineDetail(item) {
        // console.log(item)
        this.$router.push('/detail/standard-detail?sid=' + item.sid)
      },
      showOtherDetail(item) {
        this.$router.push('/detail/gsstandard-detail?sid=' + item.sid)
      }
    }
  };
</script>

<style scoped>
  @import url(./publishproject.css);

  .institutions-standard-box {
    width: 725px;
    border: 1px solid #eee;
    margin-left: 115px;
    margin-top: 30px;
    overflow: hidden;
  }

  .cs-tab-box {
    height: 40px;
    border-bottom: 2px solid rgba(0, 145, 255, 1);
    line-height: 40px;
  }

  .cs-tab-box a {
    float: left;
    width: 97px;
    text-align: center;
    color: #333333;
    font-size: 16px;
  }

  .cs-tab-box a.active {
    background: #2981F2;
    color: #fff;
  }

  .c-standard-right-box {
    float: right;
  }

  .c-standard-right-box p {
    color: #333;
    font-size: 14px;
    width: 136px;
    text-align: center;
    margin-top: 20px;
    clear: both;
    display: block;
    padding-top: 30px;
  }

  .c-standard-right-box p.p1 {
    font-size: 14px;
    color: #666;
    margin-top: 5px;
  }

  .c-standard-right-box p.c-txt-col {
    color: #267FF2;
    margin-top: 0;
    padding-top: 10px;
    font-size: 20px;
  }

  .c-standard-right-box a {
    /* float: right; */
    background: #267FF2;
    line-height: 30px;
    color: #fff;
    /* padding: 0 5px; */
    font-size: 12px;
    display: block;
    margin-top: 10px;
    text-align: center;
  }

  .standart-apply-list th {
    line-height: 48px;
    background: #F0F0F0;
    font-size: 16px;
    color: #666;
  }

  .standart-apply-list th a {
    display: block;
    width: 97px;
    height: 28px;
    line-height: 28px;
    border: 1px solid #267FF2;
    ;
    text-align: center;
    font-size: 16px;
    font-weight: normal;
    margin: 0 auto;
    color: #267FF2;
  }

  .standart-apply-list table {
    width: 100%;
    border: 1px solid #F0F0F0;
  }

  .standart-apply-list td {
    border-bottom: 1px solid #F0F0F0;
    height: 48px;
    text-align: center;
    color: #666;
  }

  .standart-apply-list td a {
    /* float: left; */
    color: #267FF2;
    /* padding-left: 20px; */
    text-align: center;
  }

  .standart-apply-list td span {
    float: center;
    color: #267FF2;
    cursor: pointer;
    text-align: center;
  }


  @media screen and (max-width: 850px) {
    .c-standard-right-box p {
      position: absolute;
      right: 0;
      padding-top: .1rem;
      top: 0;
    }

    .c-standard-right-box a {
      position: absolute;
      right: 0;
      padding: 0 .3rem;
      line-height: .56rem;
      margin-top: 0;
      font-size: .24rem;
      bottom: .3rem;
    }

    .c-standard-right-box p.p1 {
      font-size: .28rem;
      margin-top: 0.6rem;
    }

    .c-standard-right-box p.c-txt-col {
      margin-top: 1.1rem;
      font-size: .36rem;
    }

    .c-standard-right-box p {
      top: .2rem;
    }

    .institutions-standard-box {
      width: 100%;
      margin-left: 0;
    }

    .tab-box {
      height: .8rem;
      line-height: .8rem;
    }

    .tab-box a {
      width: 1.84rem;
      font-size: .32rem;
    }



    .standart-apply-list th {
      height: .6rem;
      font-size: .24rem;
      font-weight: normal;
    }

    .standart-apply-list td {
      height: .6rem;
      line-height: .6rem;
      font-size: .22rem;
    }

    .standart-apply-list td a {
      width: 100%;
      text-align: center;
      margin-left: 0;
      box-sizing: border-box;
      padding-left: 0;
      line-height: .5rem;
      height: .5rem;
    }

    .standart-apply-list .ctl-btn {
      width: 1.2rem;
      line-height: 0.4rem;
      float: right;
      color: #F0F0F0;
      margin-right: 0.02rem;
      background: #267FF2;
      text-align: center;
    }
  }
</style>
